import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { map, find, isEmpty, get } from 'lodash';
import moment from 'moment';

const defaultFilterListStyles = {
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    margin: '0px 16px 0px 16px',
  },
  chip: {
    margin: '8px 8px 0px 0px',
  },
};

const FBFilterList = ({ classes, filterList, filterUpdate, columns }) => (
  <div className={classes.root}>
    {map(filterList || {}, (item, index) => {
      const column = find(columns, { id: index });
      if (get(column, 'filterType', '') === 'date') {
        if (item[0] && item[1])
          return (
            <Chip
              label={`${column.label}: ${item.join(' - ')}`}
              key={column.id}
              onDelete={() => {
                filterUpdate(column, []);
              }}
              className={classes.chip}
            />
          );
        else return;
      }
      if (get(column, 'filterType', '') === 'range') {
        if (item[0] && item[1])
          return (
            <Chip
              label={`${column.label}: ${item.join(' - ')}`}
              key={column.id}
              onDelete={() => {
                filterUpdate(column, []);
              }}
              className={classes.chip}
            />
          );
        else return;
      }
      if (get(column, 'filterType', '') === 'manager') {
        return (item || []).map((data, colIndex) => (
          <Chip
            label={`${column.label}: ${data.name}`}
            key={colIndex}
            onDelete={() => {
              const a = item;
              a.splice(a.indexOf(data), 1);
              filterUpdate(column, a);
            }}
            className={classes.chip}
          />
        ));
      }
      if (get(column, 'filterType', '') === 'text') {
        if (Array.isArray(item)) {
          return <span></span>;
        }
        return [item].filter(Boolean).map((data, colIndex) => (
          <Chip
            label={`${column.label}: ${item.replaceAll('%', '')}`}
            key={colIndex}
            onDelete={() => {
              const a = null;
              filterUpdate(column, a);
            }}
            className={classes.chip}
          />
        ));
      }
      if (get(column, 'filterType', '') === 'text_not') {
        if (Array.isArray(item)) {
          return <span></span>;
        }
        return [item].filter(Boolean).map((data, colIndex) => (
          <Chip
            label={`${column.label}: ${item.replaceAll('%', '')}`}
            key={colIndex}
            onDelete={() => {
              filterUpdate(column, null);
            }}
            className={classes.chip}
          />
        ));
      }
      if (get(column, 'filterType', '') === 'multiselect_text') {
        if (!Array.isArray(item) || item.length === 0) {
          return <span></span>;
        }
        return (
          <Chip
            label={`${column.label}: ${item.join(', ')}`}
            key={column.id}
            onDelete={() => {
              filterUpdate(column, []);
            }}
            className={classes.chip}
          />
        );
      }
      if (get(column, 'filterType', '') === 'user_email_exclude') {
        if (!Array.isArray(item) || item.length === 0) {
          return <span></span>;
        }
        const displayNames = item.map(i => i.name || i.label || i.email || i).join(', ');
        return (
          <Chip
            label={`${column.label}: ${displayNames}`}
            key={column.id}
            onDelete={() => {
              filterUpdate(column, []);
            }}
            className={classes.chip}
          />
        );
      }
      if (get(column, 'filterType', '') === 'email_conditions') {
        if (!item || !item.conditions || item.conditions.length === 0) {
          return <span></span>;
        }
        const operatorLabels = {
          contains: 'contains',
          does_not_contain: 'does not contain',
          is: 'is',
          is_not: 'is not',
        };
        const validConditions = item.conditions.filter(c => c.value && c.value.trim() !== '');
        if (validConditions.length === 0) {
          return <span></span>;
        }
        return validConditions.map((cond, condIndex) => (
          <Chip
            label={`Email ${operatorLabels[cond.operator] || cond.operator} "${cond.value}"`}
            key={`${column.id}_${condIndex}`}
            onDelete={() => {
              const updated = item.conditions.filter((_, i) => i !== condIndex);
              filterUpdate(column, updated.length > 0
                ? { ...item, conditions: updated }
                : { mode: 'and', conditions: [] });
            }}
            className={classes.chip}
          />
        ));
      }
      return item.map((data, colIndex) => (
        <Chip
          label={`${column.label}: ${column.filterOptions ? find(column.filterOptions, { value: data }).name : data}`}
          key={colIndex}
          onDelete={() => {
            const a = item;
            a.splice(a.indexOf(data), 1);
            filterUpdate(column, a);
          }}
          className={classes.chip}
        />
      ));
    })}
  </div>
);

FBFilterList.propTypes = {
  filterList: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  filterUpdate: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(defaultFilterListStyles)(FBFilterList);
